const Content = (props) => {
  return <p>{props.content}</p>;
};

export default Content;
